import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';
import {ItemMenu} from '../../models/item-menu.model';
import {Location} from '@angular/common';
import {SelectCommoditiesService} from '../../service/select-commodities.service';
import {WizardService} from '../../service/wizard.service';
import {OrdersFilterService} from '../../../delivery/services/orders-filter.service';
import {MatSnackBar, MatSnackBarConfig} from '@angular/material/snack-bar';
import {Utilities} from '../../utilities/utilities.model';
import {AppointmentsDashboardPollingService} from '../../../appointments/services/appointments-dashboard-polling.service';
import {NavigationEnd, Router} from '@angular/router';
import {HeaderUtilitesModel} from '../../utilities/header-utilites.model';
import {
	DL_ALERTS_LIST,
	DL_APPOINTMENTS_LIST,
	DL_DASHBOARD,
	DL_ORDERS_LIST
} from '../../../delivery/delivery-routing-roots';
import {ROOT_DELIVERY, ROOT_NOTIFICATION_CENTER} from '../../../app-routing-roots';
import {PERMISSION_DELIVERY_ALERTS_READ, PERMISSION_DELIVERY_APPOINTMENTS,} from '../../../permissions-variables';
import {UserV3Service} from '@shared/service/user-v-3.service';
import {PermissionService} from '@shared/service/permission.service';
import {UserV3Model} from '@shared/models/user-v-3.model';
import {Appointments2FilterService} from '../../../appointments/services/appointments2-filter.service';
import {TranslateContext, TranslatePipe} from '@shared/pipes/translate.pipe';
import {NemoModuleKeys, UserPermissionsModel} from '@shared/models/user-permission.model';
import {OrderAlertsDashboardPollingService} from '@shared/service/order-alerts-dashboard-polling.service';
import {AlertFilterService} from '../../../delivery/services/alert-filter.service';

@Component({
	selector: 'amd-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy, OnChanges {

	@Input() itemMenuID: string;
	allTabs: Map<string, ItemMenu[]> = new Map<string, ItemMenu[]>();
	currentActiveIndex: number;
	subscriptionsSelectCommodities: Subscription;
	subscriptionsAlertsPolling: Subscription;
	subAppointmentsPolling: Subscription;
	subsAlertLastAccess: Subscription;
	showWizardButton: boolean;

	currentTabsList: ItemMenu[];
	translateContext: TranslateContext = TranslateContext.HEADER;

	constructor(public location: Location,
				public router: Router,
				public userV3Service: UserV3Service,
				public permissionService: PermissionService,
				public snackBar: MatSnackBar,
				public selectCommoditiesService: SelectCommoditiesService,
				public orderAlertsPollingService: OrderAlertsDashboardPollingService,
				public appointmentsDashboardPollingService: AppointmentsDashboardPollingService,
				public wizardService: WizardService,
				public orderFilterService: OrdersFilterService,
				public appointmentFilterService: Appointments2FilterService,
				public translatePipe: TranslatePipe,
				public alertFilterService: AlertFilterService) {
		this.settingTabs();
		this.wizardService.page_wizard.subscribe(res => this.showWizardButton = !Utilities.isVoid(res));

		this.subscriptionsSelectCommodities = this.selectCommoditiesService.commoditiesObservable.subscribe(
			() => {
				this.startPolling();
			});

		this.subsAlertLastAccess = this.userV3Service.alertLastAccessObservable.subscribe(
			() => {
				this.startDeliveryAlertsPolling();
			});
	}

	ngOnInit(): void {
		this.router.events.filter(event => event instanceof NavigationEnd).subscribe((event) => {
			this.setCurrentActiveIndex();
		});
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (!Utilities.isVoid(changes) && !Utilities.isVoid(changes.itemMenuID)) {
			this.itemMenuID = changes.itemMenuID.currentValue;
			this.setCurrentTabsList();
			this.setCurrentActiveIndex();
			this.startPolling();
		}
	}

	ngOnDestroy(): void {
		this.unSubscribeDeliveryAlertsPolling();
		this.unSubscribeDeliveryAppointmentsPolling();
		if (this.subsAlertLastAccess) {
			this.subsAlertLastAccess.unsubscribe();
		}
		if (this.subscriptionsSelectCommodities) {
			this.subscriptionsSelectCommodities.unsubscribe();
		}
	}

	private setCurrentTabsList(): void {
		this.currentTabsList = this.allTabs.get(this.itemMenuID);
	}

	private settingTabs(): void {
		
		const permissions: UserPermissionsModel = this.permissionService.getCurrentUserPermissions();
		
		this.allTabs.set(UserV3Model.DELIVERY_ASR_ITEM_MENU_ID, HeaderUtilitesModel.getItemsASRMenuDelivery());
		this.allTabs.set(UserV3Model.NOTIFICATION_CENTER_ITEM_MENU_ID, HeaderUtilitesModel.getItemsMenuNotification(permissions));
		this.allTabs.set(UserV3Model.DELIVERY_ITEM_MENU_ID, HeaderUtilitesModel.getItemsMenuDelivery(permissions));
		this.allTabs.set(UserV3Model.CONTRACT_CLOSING_SP_OP_ITEM_MENU_ID, HeaderUtilitesModel.getItemsMenuCCServicePointOperator(permissions));
		this.allTabs.set(UserV3Model.CONTRACT_CLOSING_DK_OP_ITEM_MENU_ID, HeaderUtilitesModel.getItemsMenuCCDekraOperator());
		this.allTabs.set(UserV3Model.CONTRACT_CLOSING_ALD_OP_ITEM_MENU_ID, HeaderUtilitesModel.getItemsMenuCCALDOperator(permissions));
		this.allTabs.set(UserV3Model.CONTRACT_CLOSING_DK_C_ITEM_MENU_ID, HeaderUtilitesModel.getItemsMenuCCDekraCenter());
		this.allTabs.set(UserV3Model.CONTRACT_CLOSING_DK_BO_OP_ITEM_MENU_ID, HeaderUtilitesModel.getItemsMenuCCBackOffice());
		this.allTabs.set(UserV3Model.CLAIMS_ADMIN_ITEM_MENU_ID, HeaderUtilitesModel.getItemsMenuClaimsAdmin());
		this.allTabs.set(UserV3Model.CLAIMS_CUSTOM_ADMIN_ITEM_MENU_ID, HeaderUtilitesModel.getItemsMenuClaimsCustomAdmin());
		this.allTabs.set(UserV3Model.CLAIMS_SUPERVISOR_ITEM_MENU_ID, HeaderUtilitesModel.getItemsMenuClaimsSupervisor());
		this.allTabs.set(UserV3Model.CLAIMS_OLSA_ITEM_MENU_ID, HeaderUtilitesModel.getItemsMenuClaimsOlsa());
		this.allTabs.set(UserV3Model.CLAIMS_REPAIR_ITEM_MENU_ID, HeaderUtilitesModel.getItemsMenuClaimsRepair());
		this.allTabs.set(UserV3Model.CLAIMS_THEFT_ITEM_MENU_ID, HeaderUtilitesModel.getItemsMenuClaimsTheft());
		this.allTabs.set(UserV3Model.CLAIMS_PRACTICE_CAR_ITEM_MENU_ID, HeaderUtilitesModel.getItemsMenuClaimsPracticeCar());
		this.allTabs.set(UserV3Model.CLAIMS_PRACTICES_ITEM_MENU_ID, HeaderUtilitesModel.getItemsMenuClaimsPractices());
		this.allTabs.set(UserV3Model.CLAIMS_COMPLAINT_ITEM_MENU_ID, HeaderUtilitesModel.getItemsMenuClaimsComplaint());
		this.allTabs.set(UserV3Model.AUTHORITY_ITEM_MENU_ID, HeaderUtilitesModel.getItemsMenuAuthority(permissions));
		this.allTabs.set(UserV3Model.MOBILITY_ITEM_MENU_ID, HeaderUtilitesModel.getItemsMenuMobility(permissions));
		this.allTabs.set(UserV3Model.INVOICING_ITEM_MENU_ID, HeaderUtilitesModel.getItemsMenuInvoicing(permissions));
		this.allTabs.set(UserV3Model.NOTIFICATION_CENTER_ITEM_MENU_ID, HeaderUtilitesModel.getItemsMenuNotification(permissions));
		this.allTabs.set(UserV3Model.TYRES_ITEM_OPC_MENU_ID, HeaderUtilitesModel.getItemsMenuTyresOpc(permissions));
		this.allTabs.set(UserV3Model.TYRES_ITEM_OPA_MENU_ID, HeaderUtilitesModel.getItemsMenuTyresOpa());
		this.allTabs.set(UserV3Model.TYRES_ITEM_OPF_MENU_ID, HeaderUtilitesModel.getItemsMenuTyresOpf());
		this.allTabs.set(UserV3Model.TYRES_ITEM_OPS_MENU_ID, HeaderUtilitesModel.getItemsMenuTyresOps());
		this.allTabs.set(UserV3Model.LOGISTICS_ITEM_OPL_MENU_ID, HeaderUtilitesModel.getItemsMenuLogisticsOpl());
		this.allTabs.set(UserV3Model.LOGISTICS_ITEM_OPAD_MENU_ID, HeaderUtilitesModel.getItemsMenuLogisticsOpad(permissions));
		this.allTabs.set(UserV3Model.LOGISTICS_ITEM_OPC_MENU_ID, HeaderUtilitesModel.getItemsMenuLogisticsOpc());
		this.allTabs.set(UserV3Model.LOGISTICS_ITEM_OPASR_MENU_ID, HeaderUtilitesModel.getItemsMenuLogisticsOpasr(permissions));
		this.allTabs.set(UserV3Model.USER_CHANGE_ALD_MENU_ID, HeaderUtilitesModel.getItemsMenuUCAld());
		this.allTabs.set(UserV3Model.USER_CHANGE_SP_MENU_ID, HeaderUtilitesModel.getItemsMenuUCSp(permissions));
		// this.allTabs.set(UserV3Model.ADMINISTRATION_SA_MENU_ID, HeaderUtilitesModel.getItemsMenuAdministrationSA());
		this.allTabs.set(UserV3Model.ADMINISTRATION_RULES_MENU_ID, HeaderUtilitesModel.getItemsMenuAdministrationRules());
		this.allTabs.set(UserV3Model.ADMINISTRATION_CHANNELING_MENU_ID, HeaderUtilitesModel.getItemsMenuAdministrationChanneling());
		this.allTabs.set(UserV3Model.ADMINISTRATION_USERS_MENU_ID, HeaderUtilitesModel.getItemsMenuAdministrationUsersM());
		this.allTabs.set(UserV3Model.FLOTTA_POOL_MENU_ID, HeaderUtilitesModel.getItemsMenuFlottaPool(permissions));
		this.allTabs.set(UserV3Model.BOOKINGS_RELIEF_MENU_ID, HeaderUtilitesModel.getItemsMenuBookingsRelief(permissions));
		this.allTabs.set(UserV3Model.BOOKINGS_PRELEASE_MENU_ID, HeaderUtilitesModel.getItemsMenuBookingsPrelease(permissions));
		this.allTabs.set(UserV3Model.CARGOS_ITEM_MENU_ID, HeaderUtilitesModel.getItemsMenuCargos(permissions));
	}

	private startPolling() {
		this.startDeliveryAlertsPolling();
		this.startDeliveryAppointmentsPolling();
	}

	private startDeliveryAlertsPolling() {
		if (this.itemMenuID === UserV3Model.DELIVERY_ITEM_MENU_ID
			&& this.permissionService.hasPermissions(PERMISSION_DELIVERY_ALERTS_READ)) {
			const lastRes = this.orderAlertsPollingService.lastResult;
			if (!Utilities.isVoid(lastRes)) {
				const itemMenuAlert = this.allTabs.get(UserV3Model.DELIVERY_ITEM_MENU_ID)[2];
				if (!Utilities.isVoid(itemMenuAlert)) {
					itemMenuAlert.count = lastRes;
				}
			}
			this.unSubscribeDeliveryAlertsPolling();
			this.orderAlertsPollingService.settingPolling();
			this.subscriptionsAlertsPolling = this.orderAlertsPollingService.pollingObservable.subscribe(
				(res) => {
					const itemMenuAlert = this.allTabs.get(UserV3Model.DELIVERY_ITEM_MENU_ID)[2];
					if (!Utilities.isVoid(itemMenuAlert) && itemMenuAlert.count !== res) {
						itemMenuAlert.count = res;
						if (itemMenuAlert.count > 0) {
							const path = this.location.path();
							if (path && path.indexOf('/' + ROOT_DELIVERY + '/' + DL_DASHBOARD + '/' + DL_ALERTS_LIST) >= 0) {
								const config = new MatSnackBarConfig();
								config.duration = 5000;
								config.panelClass = ['snack-bar-info'];
								this.snackBar.open(this.translatePipe.transform('HAI_RICEVUTO_NUOVI_ALERT', TranslateContext.SHARED), null, config);
							}
						}
					}
				});
		} else {
			this.unSubscribeDeliveryAlertsPolling();
		}
	}

	private startDeliveryAppointmentsPolling(): void {
		if (this.itemMenuID === UserV3Model.DELIVERY_ITEM_MENU_ID
			&& this.permissionService.hasPermissions(PERMISSION_DELIVERY_APPOINTMENTS)) {
			const lastRes: any = this.appointmentsDashboardPollingService.lastResult;
			if (!Utilities.isVoid(lastRes)) {
				const itemMenuAppointment: ItemMenu = this.allTabs.get(UserV3Model.DELIVERY_ITEM_MENU_ID)[3];
				if (!Utilities.isVoid(itemMenuAppointment)) {
					itemMenuAppointment.count = lastRes;
				}
			}
			this.unSubscribeDeliveryAppointmentsPolling();
			this.appointmentsDashboardPollingService.settingPolling();
			this.subAppointmentsPolling = this.appointmentsDashboardPollingService.pollingObservable.subscribe(
				(res) => {
					const itemMenuAppointment: ItemMenu = this.allTabs.get(UserV3Model.DELIVERY_ITEM_MENU_ID)[3];
					if (!Utilities.isVoid(itemMenuAppointment) && itemMenuAppointment.count !== res) {
						itemMenuAppointment.count = res;
					}
				});
		} else {
			this.unSubscribeDeliveryAppointmentsPolling();
		}
	}


	private unSubscribeDeliveryAlertsPolling(): void {
		if (this.orderAlertsPollingService) {
			this.orderAlertsPollingService.stopPolling();
		}
		if (this.subscriptionsAlertsPolling) {
			this.subscriptionsAlertsPolling.unsubscribe();
		}
	}

	private unSubscribeDeliveryAppointmentsPolling(): void {
		if (this.appointmentsDashboardPollingService) {
			this.appointmentsDashboardPollingService.stopPolling();
		}
		if (this.subAppointmentsPolling) {
			this.subAppointmentsPolling.unsubscribe();
		}
	}

	setCurrentActiveIndex(): void {
		if (this.currentTabsList) {
			const path: string = this.location.path();
			for (let i: number = 0; i < this.currentTabsList.length; i++) {
				const routerLink: string = this.currentTabsList[i].routerLink;
				if (path === routerLink) {  /*|| i > 0 && path.startsWith(routerLink) startsWith effettua un controllo errato se i vari tab iniziano con la rotta di un altro tab*/
					setTimeout(() => this.currentActiveIndex = i, 500);
					return;
				}
			}
		} else {
			this.currentActiveIndex = -1;
		}
	}

	startWizard(): void {
		this.wizardService.setDisplayWizard(true);
	}

	clickItem(index: number): void {
		const item: ItemMenu = this.currentTabsList[index];
		this.currentActiveIndex = (item.routerLink.startsWith('http') ? this.currentActiveIndex : index);
		switch (item.routerLink) {
			case ROOT_DELIVERY + DL_DASHBOARD + DL_ORDERS_LIST:
				this.orderFilterService.updateFilter(null);
				break;
			case ROOT_DELIVERY + DL_DASHBOARD + DL_ALERTS_LIST:
				this.alertFilterService.updateFilter(null);
				break;
			case ROOT_DELIVERY + DL_DASHBOARD + DL_APPOINTMENTS_LIST:
				this.appointmentFilterService.updateFilter(null);
				break;
		}
	}

	isMenuHidden(): boolean {
		if (Utilities.isVoid(this.permissionService.getCurrentUserPermissions())) {
			return true;
		}
		const currentUserPermissions: UserPermissionsModel = this.permissionService.getCurrentUserPermissions();
		if (this.itemMenuID === UserV3Model.AUTHORITY_ITEM_MENU_ID) {
			if (currentUserPermissions.isCenterSuperUserOperator(NemoModuleKeys.AUTHORITY)) {
				return this.permissionService.getCommoditiesFromItemMenuID(this.itemMenuID).length === 0;
			}
		}
		if (this.itemMenuID === UserV3Model.DELIVERY_ITEM_MENU_ID) {
			return currentUserPermissions.isCenterSuperUserOperator(NemoModuleKeys.DELIVERY) && this.permissionService.getCommoditiesFromItemMenuID(this.itemMenuID).length === 0;
		}
		if (this.itemMenuID === UserV3Model.CONTRACT_CLOSING_SP_OP_ITEM_MENU_ID) {
			return currentUserPermissions.isCenterSuperUserOperator(NemoModuleKeys.CONTRACT_CLOSING_) && this.permissionService.getCommoditiesFromItemMenuID(this.itemMenuID).length === 0;
		}
		if (this.itemMenuID === UserV3Model.TYRES_ITEM_OPC_MENU_ID) {
			return currentUserPermissions.isCenterSuperUserOperator(NemoModuleKeys.TYRES) && this.permissionService.getCommoditiesFromItemMenuID(this.itemMenuID).length === 0;
		}
		if (this.itemMenuID === UserV3Model.LOGISTICS_ITEM_OPASR_MENU_ID) {
			return currentUserPermissions.isCenterSuperUserOperator(NemoModuleKeys.LOGISTICS) && this.permissionService.getCommoditiesFromItemMenuID(this.itemMenuID).length === 0;
		}
		if (this.itemMenuID === UserV3Model.FLOTTA_POOL_MENU_ID) {
			return currentUserPermissions.isCenterSuperUserOperator(NemoModuleKeys.FLOTTA_POOL) && this.permissionService.getCommoditiesFromItemMenuID(this.itemMenuID).length === 0;
		}
		if (this.itemMenuID === UserV3Model.USER_CHANGE_SP_MENU_ID) {
			return currentUserPermissions.isCenterSuperUserOperator((NemoModuleKeys.USER_CHNAGE) && (NemoModuleKeys.USER_CHNAGE_)) && this.permissionService.getCommoditiesFromItemMenuID(this.itemMenuID).length === 0;
		}
		if (this.itemMenuID === UserV3Model.INVOICING_ITEM_MENU_ID) {
			return currentUserPermissions.isCenterSuperUserOperator(NemoModuleKeys.INVOICING) && this.permissionService.getCommoditiesFromItemMenuID(this.itemMenuID).length === 0;
		}
		if (this.itemMenuID === UserV3Model.NOTIFICATION_CENTER_ITEM_MENU_ID) {
			return currentUserPermissions.isSuperUserByLocationPath(ROOT_NOTIFICATION_CENTER) && this.permissionService.getCurrentUserPermissions().profiles.some(profile => profile.commodities.length === 0);
		}
		return false;
	}
}
